/**
 * Hook returning the current app context value.
 */

import { useContext } from 'react';
import { AppContext, type AppContextValue } from './appContextInstance';

export const useAppContext = (): AppContextValue => {
  const context = useContext(AppContext);
  if (context === undefined) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};
